import React from "react";
import { Link, useLocation } from "react-router-dom";
import IconRenderer from "../atoms/IconRenderer";

const NavDropdownItem = ({
  to,
  icon,
  iconType,
  isWhite = false,
  children,
  className = "",
  ...props
}) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <li>
      <Link
        to={to}
        className={`flex items-center gap-2.5 px-4 py-2 mx-2 rounded-md text-sm transition-all duration-150 ${
          isActive
            ? "text-orange-400 bg-orange-500/10"
            : "text-gray-400 hover:text-gray-200 hover:bg-white/5"
        } ${className}`}
        {...props}
      >
        <IconRenderer
          icon={icon}
          iconType={iconType}
          isWhite={isWhite}
          size="sm"
        />
        <span className="truncate">{children}</span>
      </Link>
    </li>
  );
};

export default NavDropdownItem;
